<section class="title-section">
    <div class="headline">
        <div class="intro">
            <h3 class="title">Solutions</h3>
            <p class="text">Hyperconverged &bull; Hyperautomated</p>
        </div>
    </div>

    <div class="headtext">
        <p>Secure, mission-critical SaaS solutions for those industries where efficiency, uptime, 
            privacy and security are paramount. WorldERP® provides SSAE16/SAS70 Type II, HIPPA, PCI DSS,
            and other compliance standards along with ISO/TR Bank-level equivalent security on 
            architectures where communication and data reside to be controlled with full audit tracking.</p>
    </div>
</section>